import React from "react";

export default class ExportButton extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="export-wrapper">
        <button
          type="button"
          className="btn btn-primary"
          onClick={this.props.onExport}
        >
          {I18n.t("export")}
        </button>
      </div>
    );
  }
}
